import { Organization, PointOfContact } from "../types";

export const formatPhysicalAddressWithOrganization = (
    organization: Pick<Organization, "country" | "state" | "zipcode" | "city" | "streetAddr">,
): string =>
    [
        organization.streetAddr,
        organization.city,
        organization.state,
        organization.zipcode,
        organization.country,
    ]
        .filter(Boolean)
        .join(", ");

export const formatPointOfContactAddress = (
    organization: Pick<Organization, "pointOfContact">,
): string[] =>
    organization.pointOfContact
        ?.filter((poc: PointOfContact) => poc.address)
        .map((poc: PointOfContact) =>
            [
                poc.address.country,
                poc.address.state,
                poc.address.zipcode,
                poc.address.city,
                poc.address.streetAddress,
            ]
                .filter(Boolean)
                .join(", "),
        ) || [];
